module.exports = __webpack_public_path__ + "static/media/moduleManager_white.d9f0805d.svg";